function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.2200841,14.7196742 C14.5129773,15.0125674 14.5129773,15.4874412 14.2200841,15.7803344 C13.9271909,16.0732276 13.4523172,16.0732276 13.1594239,15.7803344 L10.4398021,13.0607123 C9.85398949,12.4757342 9.85331342,11.5266219 10.4382922,10.9408019 L13.1594239,8.21966991 C13.4523172,7.9267767 13.9271909,7.9267767 14.2200841,8.21966991 C14.5129773,8.51256313 14.5129773,8.98743687 14.2200841,9.28033009 L11.5004119,12 L14.2200841,14.7196742 Z",
  transform: "matrix(1 0 0 -1 0 24)",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "media/angle-left-small.svg";
export { SvgComponent as ReactComponent };